// extracted by mini-css-extract-plugin
export default {"container":"xN-z","modal":"yN-z","dimensions":"zN-z","brandName":"AN-z","productName":"BN-z","labelValue":"CN-z","recipientEmail":"DN-z","recommendedFit":"EN-z","hiddenField":"FN-z"};